import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_fragrances_all: FaireCategoryEntity = {
  token: "cat_fragrances-all",
  type: "category",
  name: "All home fragrances",
  level: 3,
  parentToken: "cat_home-decor-fragrances",
  href: "/category/home-decor/home-fragrances",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
